(() => {
  const root = document.querySelector('[data-medit-launch]');
  if (!root) return;
  const models = {
    ie: {name:'Medit iE', warranty:'1 year', options:[['Scanner only',10999],['Scanner + laptop',13999]], availability:'Official launch October 1. Vendor inventory available October 8; confirm shipment timing with Dentcore.', extra:'Realtime Intelligence and Medit Apps are optional, sold separately.'},
    classic: {name:'Medit i900 Classic', warranty:'3 years', options:[['Scanner only',15999],['Scanner + laptop',17999]], availability:'Availability and shipment timing confirmed with your quote.', extra:'Includes six months of AuraVue Pro, available in the United States.'},
    mobility: {name:'Medit i900 Mobility', warranty:'3 years', options:[['Scanner only',15999],['Scanner + laptop',17999],['Scanner + iPad',17999],['Scanner + laptop + iPad',19999]], availability:'Availability and shipment timing confirmed with your quote.', extra:'Includes six months of AuraVue Pro, available in the United States.'}
  };
  const form=root.querySelector('form');
  if (!form) return;
  const model=form.elements.model;
  const configuration=form.elements.configuration;
  const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n);
  function update(rebuild=false) {
    const item=models[model.value];
    if(rebuild) configuration.replaceChildren(...item.options.map(([label],i)=>new Option(label,String(i))));
    const option=item.options[Number(configuration.value)] || item.options[0];
    const variant=form.querySelector('[data-purchase-variant]'); if(variant){const selected=form.querySelector('[data-config="'+configuration.value+'"]');if(selected)variant.value=selected.dataset.variant;}
    root.querySelector('[data-summary-model]').textContent=item.name;
    root.querySelector('[data-summary-config]').textContent=option[0];
    root.querySelector('[data-summary-price]').textContent=money(option[1]);
    root.querySelector('[data-summary-warranty]').textContent=item.warranty;
    root.querySelector('[data-summary-extra]').textContent=item.extra;
    root.querySelector('[data-summary-availability]').textContent=item.availability;
    const link=root.querySelector('[data-quote-link]'); const url=new URL(link.href); url.searchParams.set('interest',item.name+' - '+option[0]); url.searchParams.set('utm_source',root.dataset.partner==='tatum'?'tatum':'dentcore'); url.searchParams.set('utm_campaign','medit-2026-q4'); link.href=url.toString();
  }
  model.addEventListener('change',()=>update(true));
  configuration.addEventListener('change',()=>update());
  root.querySelectorAll('[data-choose-model]').forEach(link=>link.addEventListener('click',()=>{
    model.value=link.dataset.chooseModel;
    update(true);
  }));
  form.addEventListener('submit',event=>{if(!form.hasAttribute('data-purchase-form'))event.preventDefault()});
  update(true);
})();

if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('mq-seen');observer.unobserve(entry.target)}}),{threshold:.12});document.querySelectorAll('.mq-workflow-step').forEach(el=>{el.classList.add('mq-reveal');observer.observe(el)})}

document.querySelectorAll('[data-ie-workflow]').forEach(workflow => {
  const tabs = [...workflow.querySelectorAll('[role="tab"]')];
  function select(tab, focus = false) {
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      document.getElementById(item.getAttribute('aria-controls')).hidden = !active;
    });
    if (focus) tab.focus();
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', event => {
      const positions = {ArrowRight:(index+1)%tabs.length, ArrowLeft:(index+tabs.length-1)%tabs.length, Home:0, End:tabs.length-1};
      if (!(event.key in positions)) return;
      event.preventDefault();
      select(tabs[positions[event.key]], true);
    });
  });
});
